export default __webpack_public_path__ + "img/publication/publication7_1500.webp";